<div class="primary-info-box modal-box">
  <div class="row date-row">
    <div class="col-sm-7 col-6 text-align-left">
      <span> {{ 'app_taxes_amount_not_financed' | translate }} </span>
    </div>
    <div class="col-sm-5 col-6 text-align-right">
      <span class="nowrap"> {{ amountNotFinanced | number: '1.2-2' }} € </span>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12 col-sm-6">
    <div class="primary-info-box modal-box">
      <div class="row date-row">
        <div class="col-12">
          <span>{{ 'app_taxes_home_expenses' | translate }}</span>
        </div>
      </div>
      <div class="row date-row">
        <div class="col-6 text-align-left">
          <span>{{ 'app_taxes_taxes' | translate }}</span>
        </div>
        <div class="col-6 text-align-right">
          <span class="nowrap"> {{ mortgageResult?.expenses?.trading?.taxes | number: '1.2-2' }} €</span>
        </div>
      </div>
      <div class="row date-row">
        <div class="col-6 text-align-left">
          <span>{{ 'app_taxes_notary' | translate }}</span>
        </div>
        <div class="col-6 text-align-right">
          <span class="nowrap"> {{ totalNotaryTrading() | number: '1.2-2' }} €</span>
        </div>
      </div>
      <div class="row date-row">
        <div class="col-6 text-align-left">
          <span>{{ 'app_taxes_register' | translate }}</span>
        </div>
        <div class="col-6 text-align-right">
          <span class="nowrap"> {{ mortgageResult?.expenses?.trading?.register?.cost | number: '1.2-2' }} €</span>
        </div>
      </div>
      <div class="row date-row">
        <div class="col-6 text-align-left">
          <span>{{ 'app_taxes_agency' | translate }}</span>
        </div>
        <div class="col-6 text-align-right">
          <span class="nowrap"> {{ mortgageResult?.expenses?.trading?.agency?.cost | number: '1.2-2' }} €</span>
        </div>
      </div>
      <div class="row date-row w-border">
        <div class="col-6 text-align-left">
          <span>{{ 'app_taxes_total' | translate }}</span>
        </div>
        <div class="col-6 text-align-right">
          <span class="nowrap"> {{ mortgageResult?.expenses?.trading?.total | number: '1.2-2' }} €</span>
        </div>
      </div>
      <div class="row date-row">
        <div class="col-6 text-align-left"><span>&nbsp;</span></div>
        <div class="col-6 text-align-right"><span>&nbsp;</span></div>
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-6">
    <div class="primary-info-box modal-box">
      <div class="row date-row">
        <div class="col-12">
          <span>{{ 'app_taxes_mortgage_expenses' | translate }}</span>
        </div>
      </div>
      <div class="row date-row">
        <div class="col-6 text-align-left">
          <span>{{ 'app_taxes_taxes' | translate }}</span>
        </div>
        <div class="col-6 text-align-right">
          <span class="nowrap"> {{ mortgageResult?.expenses?.mortgage?.taxes | number: '1.2-2' }} €</span>
        </div>
      </div>
      <div class="row date-row">
        <div class="col-6 text-align-left">
          <span>{{ 'app_taxes_notary' | translate }}</span>
        </div>
        <div class="col-6 text-align-right">
          <span class="nowrap"> {{ totalNotaryMortgage() | number: '1.2-2' }} €</span>
        </div>
      </div>
      <div class="row date-row">
        <div class="col-6 text-align-left">
          <span>{{ 'app_taxes_register' | translate }}</span>
        </div>
        <div class="col-6 text-align-right">
          <span class="nowrap"> {{ mortgageResult?.expenses?.mortgage?.register?.cost | number: '1.2-2' }} €</span>
        </div>
      </div>
      <div class="row date-row">
        <div class="col-6 text-align-left">
          <span>{{ 'app_taxes_agency' | translate }}</span>
        </div>
        <div class="col-6 text-align-right">
          <span class="nowrap"> {{ mortgageResult?.expenses?.mortgage?.agency?.cost | number: '1.2-2' }} €</span>
        </div>
      </div>
      <div class="row date-row w-border">
        <div class="col-6 text-align-left">
          <span>{{ 'app_taxes_appraisal' | translate }}</span>
        </div>
        <div class="col-6 text-align-right">
          <span class="nowrap"> {{ mortgageResult?.expenses?.mortgage?.assessment?.cost | number: '1.2-2' }} €</span>
        </div>
      </div>
      <div class="row date-row">
        <div class="col-6 text-align-left">
          <span>{{ 'app_taxes_total' | translate }}</span>
        </div>
        <div class="col-6 text-align-right">
          <span class="nowrap"> {{ mortgageResult?.expenses?.mortgage?.total | number: '1.2-2' }} €</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="primary-info-box modal-box">
  <div class="row result-data">
    <div class="col-7 text-align-left">
      <span class="succes-text"
        >{{ 'app_taxes_expenses_assumes' | translate
        }}<a
          id="taxes-modal-expenses-pibank"
          class="icon-a"
          href="javascript:void(0)"
          (click)="openToast('taxes-modal-expenses-pibank')"
          tooltipEvent="focus"
          [pTooltip]="'app_taxes_expenses_assumes_tooltip' | translate"
        >
          <img class="ico-info" src="assets/img/info.svg" />
        </a>
      </span>
    </div>
    <div class="col-5 text-align-right effort-number">
      <span class="succes-text nowrap">- {{ getBonus() | number: '1.2-2' }} €</span>
    </div>
  </div>
</div>
